import React from 'react';
import { useTranslation } from 'react-i18next';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import DebtTable from './DebtTable';
import DebtStrategyToggle from './DebtStrategyToggle';
import DebtPayoffChart from './DebtPayoffChart';

export default function DebtPlanner() {
  const { t } = useTranslation();

  return (
    <Card elevation={2}>
      <CardContent>
        <Typography variant="h6" fontWeight={600} sx={{ mb: 1, color: '#1E3A5F' }}>
          {t('budgetPlanner.debt.title', 'Plan de pago de deudas')}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {t('budgetPlanner.debt.subtitle', 'Agrega tus deudas y elige una estrategia para ver cuándo serás libre de deudas.')}
        </Typography>

        <DebtTable />

        <Divider sx={{ my: 3 }} />

        <Box sx={{ mb: 3 }}>
          <DebtStrategyToggle />
        </Box>

        <DebtPayoffChart />
      </CardContent>
    </Card>
  );
}
